import * as Yup from 'yup';

import { phoneRegex } from '../../utils/utils';

export const ClearerUserSchema = Yup.object().shape({
  firstName: Yup.string().min(1).required('First name is required'),
  lastName: Yup.string().min(1).required('Last name is required'),
  userName: Yup.string().min(1).required('Username is required'),
  email: Yup.string().email().required('Email is required'),
  phoneNumber: Yup.string()
    .matches(phoneRegex, 'Invalid Nigerian phone number')
    .required('Phone number is required'),
  warehouseId: Yup.string().min(1).required('Warehouse is required'),
});

export type ClearerUserDataType = Yup.InferType<typeof ClearerUserSchema>;

type InitialValues = {
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
  phoneNumber: string;
  warehouseId: string;
};

export const ClearerUserInitialValues: InitialValues = {
  firstName: '',
  lastName: '',
  userName: '',
  email: '',
  phoneNumber: '',
  warehouseId: '',
};

export interface IClearerUserResponse {}

export interface IClearerUserRequest {
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
  phoneNumber: string;
  warehouseId: string;
}
